import { render } from "./NewMember.vue?vue&type=template&id=58848bde&scoped=true"
import script from "./NewMember.vue?vue&type=script&lang=js"
export * from "./NewMember.vue?vue&type=script&lang=js"

import "./NewMember.vue?vue&type=style&index=0&id=58848bde&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58848bde"]])

export default __exports__